module.exports = {"TXTWCL_Star_Sub_enabled_selection":{"id":"TXTWCL_Star_Sub_enabled_selection","defaultMessage":"Активированный исход \"Звездная замена\""}}